import {NullAsDefault} from "views/Shared";
import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import('./Invite'),
  loading: NullAsDefault
})
